export const FAKE_API_URL = "https://fakestoreapi.com";
